<div
  [ngStyle]="{
    'background-color':
      ticketSchedule.ticket.status == 'SOLD_OUT' ? '#F7F7FD' : '',
    'padding-top': ticketSchedule.ticket.status == 'SOLD_OUT' ? '0px' : '20px',
    border: counter > 0 ? '1px solid #43c0b5' : '1px solid #eaeaf1'
  }"
  class="mb-4 ticket-card"
>
  <div
    *ngIf="ticketSchedule.ticket.status == 'SOLD_OUT'"
    class="d-flex justify-content-end"
  >
    <span
      class="soldout"
      [ngStyle]="{
      'border-radius':
        translate.currentLang =='ar' ? '16px 0px' : '0px 16px',
    }"
    >
      {{ "Sold out" | translate }}
    </span>
  </div>
  <div class="d-flex justify-content-between px-4">
    <div
      (click)="ticketExpanded = !ticketExpanded"
      class="d-flex align-items-center flex-1 justify-content-between mobile-ticket-details"
    >
      <div class="d-flex align-items-center">
        <i *ngIf="!ticketExpanded" class="fas fa-chevron-down"></i>
        <i *ngIf="ticketExpanded" class="fas fa-chevron-up"></i>
        <p class="title-ticket px-2 mb-0">
          {{ helpers.getElementTranslatedName(ticketSchedule.ticket) }}
        </p>
      </div>

      <p class="price-ticket px-2 mb-0">
        <ng-container *ngIf="ticketSchedule.ticket.price !== 0">
          <span
            [innerHTML]="
              ticketSchedule.ticket.price
                | toVat
                | number : '1.2-2'
                | customCurrency : 'SAR' : 'symbol' : '#727385' : 28
            "
          ></span>
        </ng-container>

        <ng-container *ngIf="ticketSchedule.ticket.price === 0">
          {{ "free" | translate }}
        </ng-container>
      </p>
    </div>
    <div class="d-flex align-items-center">
      <div class="d-flex gap-1 align-items-center">
        <button
          class="btn round-btn plus"
          (click)="increaseCount()"
          [disabled]="
            !increaseCountEnabled() ||
            ticketSchedule.ticket.status == 'SOLD_OUT'
          "
          [ngStyle]="{
                      'background-color':
                        ticketSchedule.ticket.status == 'SOLD_OUT' ? 'transparent' : '',
                  
                    }"
        >
          <i class="fas fa-plus"></i>
        </button>
        <button
          disabled
          class="btn round-btn"
          style="color: #555770; font-size: 20px"
        >
          {{ counter }}
        </button>
        <button
          class="btn round-btn minus"
          (click)="decreaseCount()"
          [disabled]="
            !decreaseCountEnabled() ||
            ticketSchedule.ticket.status == 'SOLD_OUT'
          "
          [ngStyle]="{
              'background-color':
                ticketSchedule.ticket.status == 'SOLD_OUT' ? 'transparent' : '',
          
            }"
        >
          <i class="fas fa-minus"></i>
        </button>
        <img
          (click)="deleteItem()"
          *ngIf="counter > 0 && isMobile"
          src="assets/images/icons/trash-red.svg"
          style="height: 20px; width: 20px"
        />
      </div>
    </div>
  </div>
  <div *ngIf="ticketExpanded" class="px-4">
    <p class="descr-ticket">
      {{ helpers.getElementTranslatedDescBase(ticketSchedule.ticket) }}
    </p>
    <div
      *ngIf="ticketSchedule.ticket?.attachments?.length > 0"
      class="d-flex gap-1 align-items-center"
      style="cursor: pointer"
    >
      <img class="gallery-icon" src="assets/images/tickets/gallery.png" />
      <span (click)="open(0)" class="gallery-span">{{
        "check-photos" | translate
      }}</span>
    </div>
  </div>
</div>
